import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableText, CommonText } from "styledComponents/common";

import Bean from "../../assets/img/icons/delete_normal.svg";
import Pencil from "../../assets/img/icons/edit-2.svg";
import audioIcon from "../../assets/img/icons/play-icon.svg";
import TaskActionTooltip from "../../components/Tooltip/TaskActionTooltip";
import { CommonFlexIcon, CommonImage } from "../../styledComponents/common";
import {
  LineItemTableHeaderContainer,
  LineItemTableRowContainer,
} from "../Jobs/CreateJob/createTaskStyles";
import { IconButtonHolder } from "../Jobs/tasksStyles";
import { currencySymbolMap } from '../../utils/currencies';
import {
  EvidenceIcon,
  EvidenceIconSection,
} from "../Jobs/JobApproval/taskApprovalStyle";

const { TableItem } = require("styledComponents/teams");

const pageName={
  "approval": "10px minmax(50px, 2fr) minmax(30px,70px) 70px 100px 100px 70px minmax(80px, 1fr)",
  "other": "10px minmax(50px, 2fr) minmax(30px,70px) minmax(50px, 2fr) 70px 100px 100px 70px minmax(80px, 1fr)"
}


const LineItemsTable = ({
  itemArray,
  onEditItem,
  onDeleteItem,
  totalCalc = "0.00",
  currency = { value: "USD" },
  isDetailView: isDetailViewProp,
  onImageClick,
  onAudioClick,
  getDuration,
  pageName = "other",
}) => {
  const isDetailView = isDetailViewProp !== undefined ? isDetailViewProp : (!onEditItem && !onDeleteItem);
  const { t } = useTranslation();
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const handleDelete = index => {
    if (onDeleteItem) {
      onDeleteItem(index);
    }
  };

  const handleEdit = index => {
    if (onEditItem) {
      onEditItem(index);
    }
  };
  return (
    <div>
      <LineItemTableHeaderContainer columns={pageName[pageName]}>
        <TableItem>
          <TableText>#</TableText>
        </TableItem>
        <TableItem>
          <TableText>Name</TableText>
        </TableItem>
        <TableItem>
          <TableText>Item Type</TableText>
        </TableItem>
        {pageName !== "approval" && <TableItem>
          <TableText>Description</TableText>
        </TableItem>}
        <TableItem>
          <TableText>Quantity</TableText>
        </TableItem>
        <TableItem>
          <TableText>Unit Price</TableText>
        </TableItem>
        <TableItem>
          <TableText>Amount</TableText>
        </TableItem>
        <TableItem>
          <TableText>Evidence</TableText>
        </TableItem>
        {isDetailView ? (
          <TableItem>
            <TableText>Files</TableText>
          </TableItem>
        ) : (
          <TableItem>
            <TableText>Actions</TableText>
          </TableItem>
        )}
      </LineItemTableHeaderContainer>

      {itemArray.map((item, index) => (
        <LineItemTableRowContainer
          columns={pageName[pageName]}
          key={index}
        //   isLastItem={index === itemArray.length - 1}
        isLastItem={false}
        >
          <TableItem>
            <TableText>{index + 1}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.name}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.itemType}</TableText>
          </TableItem>
          {pageName !== "approval" && <TableItem>
            <TableText>{item.description || "-"}</TableText>
          </TableItem>}
          <TableItem>
            <TableText>{item.quantity !== undefined && item.quantity !== null
                  ? item.quantity
                  : '-'}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.unitPrice
                  ? `${currencySymbolMap[currency?.value || currency] || ''} ${item.unitPrice}`
                  : '-'}</TableText>
          </TableItem>
          <TableItem>
            <TableText>
              {item.amount
                  ? `${currencySymbolMap[currency?.value || currency] || ''} ${item.amount}`
                  : '-'}
            </TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.evidenceToggle ? "Yes" : "No"}</TableText>
          </TableItem>
          {isDetailView ? (
            <TableItem>
              <EvidenceIconSection>
                {item.evidences &&
                  item.evidences.length > 0 &&
                  item.evidences.map((evidence, evIndex) => (
                    <Fragment
                      key={`lineitem-${item.id || index}-evidence-${evidence.id || evIndex}`}
                    >
                      {evidence.image && (
                        <EvidenceIcon
                          onClick={() =>
                            onImageClick && onImageClick(evidence.image)
                          }
                        >
                          <CommonImage
                            src={evidence.image}
                            alt="img"
                          />
                        </EvidenceIcon>
                      )}
                      {evidence.audio && (
                        <EvidenceIcon
                          onClick={() =>
                            onAudioClick && onAudioClick(evidence.audio)
                          }
                        >
                          <CommonImage
                            src={audioIcon}
                            alt=""
                          />
                          {getDuration && (
                            <span
                              style={{
                                fontSize: "10px",
                                color: "#2266EF",
                                fontWeight: "600",
                              }}
                            >
                              {getDuration(evidence.audio)}
                            </span>
                          )}
                        </EvidenceIcon>
                      )}
                    </Fragment>
                  ))}
                {(!item.evidences ||
                  item.evidences.length === 0) && (
                  <CommonText fontSize="12px">-</CommonText>
                )}
              </EvidenceIconSection>
            </TableItem>
          ) : (
            <TableItem>
              <CommonFlexIcon gap="0px">
                <IconButtonHolder
                  onMouseEnter={() => toolTipChange(1, index)}
                  onMouseLeave={() => toolTipChange(-1)}
                  onClick={() => handleEdit(index)}
                >
                  <CommonImage src={Pencil} alt="pencil" size="24px" />
                  {selectIndex === index && toolTip === 1 && (
                    <TaskActionTooltip toolTipText={t("edit")} />
                  )}
                </IconButtonHolder>
                <IconButtonHolder
                  onMouseEnter={() => toolTipChange(3, index)}
                  onMouseLeave={() => toolTipChange(-1)}
                  onClick={() => handleDelete(index)}
                >
                  <CommonImage src={Bean} alt="" size="24px" />
                  {selectIndex === index && toolTip === 3 && (
                    <TaskActionTooltip toolTipText={t("delete")} />
                  )}
                </IconButtonHolder>
              </CommonFlexIcon>
            </TableItem>
          )}
        </LineItemTableRowContainer>
      ))}

      {itemArray?.length > 0 && (
        <LineItemTableRowContainer columns={pageName[pageName]}>
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
          {pageName !== "approval" && <TableItem>
            <TableText />
          </TableItem>}
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText name fontWeight="bold" > Total </TableText>
          </TableItem>
          <TableItem>
            <TableText name color="#2266EF" fontWeight="bold" >
              {currencySymbolMap[currency?.value || currency] || ''} {totalCalc}
            </TableText>
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
        </LineItemTableRowContainer>
      )}
    </div>
  );
};

export default LineItemsTable;
